const map = {
	"./ModuleApiSchema/registry/menu.js": 3753,
	"./ModuleCompany/ConfigSystem/registry/menu.js": 49147,
	"./ModuleConsole/ServiceRegister/registry/menu.js": 13166,
	"./ModuleConsole/ServiceSchema/registry/menu.js": 5664,
	"./ModuleCore/ApiKeyCredentials/registry/menu.js": 50639,
	"./ModuleCore/ApiKeyPermission/registry/menu.js": 95170,
	"./ModuleCore/ApiKeyPermissionGroup/registry/menu.js": 43247,
	"./ModuleCore/ApiKeyPermissionGroupCredentials/registry/menu.js": 32581,
	"./ModuleCore/ApiKeyPermissionGroupMapping/registry/menu.js": 91725,
	"./ModuleCore/ApiKeyPermissionMapping/registry/menu.js": 26306,
	"./ModuleCore/AuthzPermission/registry/menu.js": 77239,
	"./ModuleCore/AuthzPermissionGroup/registry/menu.js": 99348,
	"./ModuleCore/AuthzPermissionGroupMapping/registry/menu.js": 87816,
	"./ModuleCore/AuthzSubject/registry/menu.js": 59486,
	"./ModuleCore/AuthzSubjectPermission/registry/menu.js": 70945,
	"./ModuleCore/AuthzSubjectPermissionGroup/registry/menu.js": 7886,
	"./ModuleCore/CacheSystem/registry/menu.js": 40499,
	"./ModuleCore/ConfigSystem/registry/menu.js": 36237,
	"./ModuleCore/Tenant/registry/menu.js": 88006,
	"./ModuleCore/TenantAdminAuditLog/registry/menu.js": 8548,
	"./ModuleCore/TenantAuthPolicy/registry/menu.js": 9090,
	"./ModuleCore/TenantInvitation/registry/menu.js": 55477,
	"./ModuleCore/TenantMember/registry/menu.js": 56548,
	"./ModuleCore/TenantUserMapping/registry/menu.js": 13003,
	"./ModuleCore/User/registry/menu.js": 97849,
	"./ModuleCore/UserForceSession/registry/menu.js": 12828,
	"./ModuleCore/UserLoginActivity/registry/menu.js": 66685,
	"./ModuleCore/UserTwoFaCredential/registry/menu.js": 84579,
	"./ModuleCrm/ConfigSystem/registry/menu.js": 83934,
	"./ModulePersonalize/PnlConfigSystem/registry/menu.js": 9394,
	"./ModulePrice/ConfigSystem/registry/menu.js": 72057,
	"./ModuleRole/GrantedUser/registry/menu.js": 7507,
	"./ModuleRole/Permission/registry/menu.js": 79424,
	"./ModuleRole/PermissionGroup/registry/menu.js": 48109,
	"./ModuleRole/PermissionGroupMapping/registry/menu.js": 64271,
	"./ModuleRole/PermissionGroupUser/registry/menu.js": 73690,
	"./ModuleRole/UserAuthority/registry/menu.js": 21895,
	"./ModuleRole/UserAuthorityMapping/registry/menu.js": 29733
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70175;